import api, { openApi } from "../../services/api";
import { cachedApi } from "../../services/cachedApi";

const usePlans = () => {

    const getPlanList = async (params) => {
        const { data } = await openApi.request({
            url: '/plans/list',
            method: 'GET',
            params
        });
        return data;
    }

    const list = async (params) => {
        const { data } = await api.request({
            url: '/plans/all',
            method: 'GET',
            params
        });
        return data;
    }

    const save = async (data) => {
        const { data: responseData } = await api.request({
            url: '/plans',
            method: 'POST',
            data
        });
        cachedApi.plans.invalidate();
        return responseData;
    }

    const update = async (data) => {
        const { data: responseData } = await api.request({
            url: `/plans/${data.id}`,
            method: 'PUT',
            data
        });
        cachedApi.plans.invalidate();
        return responseData;
    }

    const remove = async (id) => {
        const { data } = await api.request({
            url: `/plans/${id}`,
            method: 'DELETE'
        });
        cachedApi.plans.invalidate();
        return data;
    }

    // Plano da empresa: era buscado a cada ticket aberto (MessageInput,
    // QueueModal). Cache curto — o plano muda por ação do super admin.
    const getPlanCompany = (params, id) => cachedApi.plans.company(id, params);

    return {
        getPlanList,
        list,
        save,
        update,
        remove,
        getPlanCompany
    }
}

export default usePlans;